<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeProspectingModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Propostas e Aprovação</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table :headers="headers" :items="proposalList" :loading="loadingTable" class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Propostas</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                </template>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.statusFormated="{ item }">
            <v-chip :color="getColor(item.statusFormated)" dark>
              {{ item.statusFormated }}
            </v-chip>
          </template>
          <template v-slot:item.revision="{ item }">
            <span>
              {{ truncateText(item.revision.observation) }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <template>
              <v-btn elevation="2"  @click="openObservationDialog(item)">
                <v-icon color="primary">
                  mdi-note-search
                </v-icon>
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="2" v-bind="attrs" v-on="on"  
                      :disabled="item.statusFormated != 'Aprovada' && isFranchisee"
                      :loading="idProposalPDF === item.id_doc "
                    >
                      <v-icon color="primary">
                        mdi-file-pdf-box
                      </v-icon>
                    </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(menuIten, index) in itemsMenuPDF" :key="index" link
                    @click="pdfRequest(item, menuIten.value)">
                    <v-list-item-title>{{
                      menuIten.title
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </template>
        </v-data-table>
      </v-card>
      <v-col cols="auto">
        <v-dialog
          v-model="dialog"
          transition="dialog-top-transition"
          max-width="600"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            > Observação </v-toolbar>
            <v-card-text>
              <v-col>
                {{ itensDialog.revision.observation }}
              </v-col>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="dialog = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-dialog>
    <v-dialog v-model="dialogDownload" max-width="400">
      <v-card>
        <v-card-title class="headline">Salvar Arquivo</v-card-title>
        <v-card-text>
          Clique abaixo para salvar o arquivo.
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="fileLink" download>
            <v-btn color="success" text @click="dialogDownload = false">
              Salvar Arquivo
            </v-btn>
          </a>
          <v-btn color="error" text @click="dialogDownload = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Approval from "./Approval.js";
export default Approval;
</script>

<style scoped>

</style>